// 引入index.js
import serviceAxios from './index.js'



// get实例  获取我的信息
// export const getMyInfo = (params) => {
//   return serviceAxios({
//     method: "get",
//     url: "/api/index/my",
//     params,
//   })
// };

// get实例
export const getJdk = (params) => {
  return serviceAxios({
    method: "get",
    url: "/api/mp/mp/jssdk",
    params,
  })
};
// post实例  识别身份证人像面
export const idCardRecognition = (data,custom) =>{
  return serviceAxios({
    method: "post",
    url: "/api/person/identifyIdCard",
    data,
    custom
  })
};
// post实例  获取验证码
export const getVerificationCode = (data,custom) =>{
  return serviceAxios({
    method: "post",
    url: "/api/fdd/sendFddCode",
    data,
    custom
  })
};


// post实例  识别银行卡
export const bankRecognition = (data,custom) =>{
  return serviceAxios({
    method: "post",
    url: "/api/person/identifyBankCard",
    data,
    custom
  })
};

// post实例  提交验证
export const authUserForApi = (data,custom) =>{
  return serviceAxios({
    method: "post",
    url: "/api/fdd/authUserForApi",
    data,
    custom
  })
};

// post实例  获取协议富文本
export const getRichText = (params,custom) =>{
  return serviceAxios({
    method: "get",
    url: "/api/fdd/getAgreement",
    params,
    custom
  })
};
// post实例  上传图片
export const uploadImg = (formData,custom) =>{
  console.log(formData)
  return serviceAxios({
    method: "post",
    url: "/api/common/upload",
    data: formData,
    custom
  })
};



// WEBPACK FOOTER //
// ./src/api/api.js